export const stories = [
  {
    id: "1",
    name: "林夏",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=160&q=80",
    mine: true,
  },
  {
    id: "2",
    name: "阿远",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=160&q=80",
  },
  {
    id: "3",
    name: "Momo",
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=160&q=80",
  },
  {
    id: "4",
    name: "陈屿",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=160&q=80",
  },
  {
    id: "5",
    name: "小满",
    avatar:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=160&q=80",
  },
  {
    id: "6",
    name: "也白",
    avatar:
      "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=160&q=80",
  },
];

export const initialPosts = [
  {
    id: "101",
    author: "周屿",
    username: "zhouyu.design",
    location: "品牌视觉 · 海报设计",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=160&q=80",
    artwork: {
      theme: "acid",
      eyebrow: "SPRING / 2026",
      title: "春日\n新味",
      subtitle: "SEASONAL DRINKS",
      code: "NO. 014",
    },
    caption: "为独立茶饮品牌设计的春季上新主视觉。用荧光绿与高密度黑体制造新鲜、醒目的货架感。",
    likes: 2386,
    comments: 48,
    time: "18 分钟前",
    liked: false,
    saved: false,
    tags: ["海报设计", "品牌视觉", "字体排版"],
  },
  {
    id: "102",
    author: "Momo",
    username: "momo.visual",
    location: "活动视觉 · 音乐节",
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=160&q=80",
    artwork: {
      theme: "pulse",
      eyebrow: "LIVE IN SHANGHAI",
      title: "声浪\n现场",
      subtitle: "MUSIC FESTIVAL",
      code: "08.16—08.18",
    },
    caption: "城市音乐节主视觉提案。通过超大字号、错位网格与色彩叠印表达现场声浪的冲击感。",
    likes: 964,
    comments: 21,
    time: "1 小时前",
    liked: true,
    saved: true,
    tags: ["主视觉", "音乐节", "版式设计"],
  },
  {
    id: "103",
    author: "陈墨",
    username: "chenmo.studio",
    location: "展览视觉 · 文化艺术",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=160&q=80",
    artwork: {
      theme: "editorial",
      eyebrow: "CONTEMPORARY ART",
      title: "边界\n之外",
      subtitle: "BEYOND THE BORDER",
      code: "07.28 / ART SPACE",
    },
    caption: "当代艺术展宣传海报系列。以克制的网格和非对称留白建立展览的理性气质。",
    likes: 1281,
    comments: 35,
    time: "3 小时前",
    liked: false,
    saved: false,
    tags: ["展览海报", "编辑设计", "网格系统"],
  },
];

export const exploreWorks = [
  { theme: "cobalt", eyebrow: "TYPE 01", title: "字体\n实验", subtitle: "TYPE MATTERS", code: "A—Z" },
  { theme: "coral", eyebrow: "BRAND NEW", title: "果味\n夏日", subtitle: "FRESH & BRIGHT", code: "2026" },
  { theme: "mono", eyebrow: "DESIGN WEEK", title: "设计\n发生", subtitle: "MAKE IT VISIBLE", code: "10.21" },
  { theme: "lavender", eyebrow: "NEW EXHIBITION", title: "流动\n之间", subtitle: "FLOWING SPACE", code: "NO. 07" },
  { theme: "sunset", eyebrow: "SALE CAMPAIGN", title: "夏促\n上新", subtitle: "SUMMER SALE", code: "50% OFF" },
  { theme: "acid", eyebrow: "COFFEE LAB", title: "醒来\n以后", subtitle: "AFTER AWAKE", code: "07:30" },
  { theme: "pulse", eyebrow: "CREATIVE TALK", title: "灵感\n开场", subtitle: "IDEAS ON STAGE", code: "SAT." },
  { theme: "editorial", eyebrow: "BOOK DESIGN", title: "纸上\n秩序", subtitle: "ORDER ON PAPER", code: "VOL. 03" },
  { theme: "mint", eyebrow: "CITY MARKET", title: "周末\n市集", subtitle: "LOCAL & LOVELY", code: "11—18" },
];

export const conversations = [
  {
    id: "501",
    name: "周屿",
    avatar: stories[1].avatar,
    preview: "第二版海报已上传，请查收",
    time: "刚刚",
    unread: 2,
  },
  {
    id: "502",
    name: "Momo",
    avatar: stories[2].avatar,
    preview: "好的，那我们周六见 👋",
    time: "12 分钟",
    unread: 0,
  },
  {
    id: "503",
    name: "陈墨",
    avatar: stories[3].avatar,
    preview: "分享了一个品牌视觉案例",
    time: "昨天",
    unread: 0,
  },
];

export const orders = [
  {
    id: "QO20260728018",
    title: "咖啡品牌夏季上新海报设计",
    role: "需求方",
    status: "OPEN_FOR_GRAB",
    statusLabel: "等待接单",
    amount: "699.00",
    date: "2026-07-28",
  },
  {
    id: "QO20260726009",
    title: "城市音乐节全套宣传物料设计",
    role: "服务者",
    status: "IN_SERVICE",
    statusLabel: "服务进行中",
    amount: "1,280.00",
    date: "2026-07-26",
  },
  {
    id: "QO20260718031",
    title: "电商品牌夏促主视觉延展",
    role: "需求方",
    status: "COMPLETED",
    statusLabel: "已完成",
    amount: "399.00",
    date: "2026-07-18",
  },
];
